<template>
  <div class="wc-banner">
    <button class="wc-banner__back" @click="$emit('back')" aria-label="返回"></button>
    <div class="wc-banner__content">
      <div class="wc-banner__title">2026 美加墨世界杯</div>
      <div class="wc-banner__sub">美国 · 加拿大 · 墨西哥 | 06.12 — 07.20</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorldCupAppBanner'
}
</script>

<style scoped lang="scss">
.wc-banner {
  position: relative;
  box-sizing: border-box;
  min-height: calc(92px + var(--wc-status-top, 0px));
  padding: calc(12px + var(--wc-status-top, 0px)) 48px 12px;
  color: #1a1a1a;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, .92), rgba(255, 244, 214, .9)),
    url('~@/assets/image/worldcup2026/site-assets/banner-bg.png') center/cover no-repeat;
  overflow: hidden;
}

.wc-banner__back {
  position: absolute;
  left: 14px;
  top: calc(14px + var(--wc-status-top, 0px));
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
}

.wc-banner__back::before {
  content: '';
  position: absolute;
  left: 9px;
  top: 7px;
  width: 10px;
  height: 10px;
  border-left: 2px solid #1a1a1a;
  border-bottom: 2px solid #1a1a1a;
  transform: rotate(45deg);
}

.wc-banner__content {
  padding-top: 10px;
  text-align: center;
}

.wc-banner__title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
}

.wc-banner__sub {
  margin-top: 4px;
  font-size: 13px;
  color: #6b7280;
}
</style>
